<se-inbox-element *ngIf="elementReady" [seConfig]="messagingConfig"></se-inbox-element>
